


































import Vue from 'vue'
export default Vue.extend({
  name: 'VideoModal',
  data () {
    return {
      videoId: this.$store.state.video.videoId,
      aspect: this.$store.state.video.aspect
    }
  }
})
